import React from "react";
import { RECAPTCHA_SITE_KEY } from "../../../env";

export const InjectReCaptcha = (ComposedComponent) => {
  class hoc extends React.Component {
    componentDidMount() {
      if (RECAPTCHA_SITE_KEY) {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
        script.addEventListener("load", this.handleLoaded);
        document.body.appendChild(script);
      }
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return hoc;
};
